import React, { useCallback } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { makeIsDemo } from "@client.pages/Login/reducer";
import useModal from "@client.hooks/useModal";

export const useDemo = () => {
  const isDemo = useSelector(makeIsDemo);
  const { t } = useTranslation();
  const { showModal } = useModal();

  const showDemoRestrictionModal = useCallback(() => {
    showModal({
      title: t("components.DemoMode.restrictedTitle"),
      component: (
        <div className="demo-restriction-message">
          {t("components.DemoMode.restrictedMessage")}
        </div>
      ),
      footerButtons: [
        {
          text: t("components.DemoMode.okButton"),
          onClick: () => Promise.resolve({}),
        },
      ],
    });
  }, [showModal, t]);

  const withDemoCheck = useCallback(
    (action) => {
      if (isDemo) {
        showDemoRestrictionModal();
        return;
      }
      action();
    },
    [isDemo, showDemoRestrictionModal]
  );

  return {
    isDemo,
    canEdit: !isDemo,
    canDelete: !isDemo,
    canCreate: !isDemo,
    canSync: !isDemo,
    showDemoRestrictionModal,
    withDemoCheck,
  };
};
